var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoCollaboratorsAdded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 202,
    viewBox: "0 0 244 202",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "7ndp3xckha",
    d: "M0 0h92.233v92.137H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6176F4",
    d: "M106.654 69.585 81.018 36.611 65.25 75.278z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.262 97.574c-5.1-13.443-28.943-23.858-38.232-24.64-30.266-2.544-45.46 27.792-45.874 37.487-.415 9.695 11.254 14.013 5.673 22.78-4.104 6.445-15.68 16.125-22.03 27.227a69.453 69.453 0 0 0 20.96 20.771c20.819 3.818 49.33 6.647 64.546 5.119a69.08 69.08 0 0 0 11.519-6.348c2.5-9.217-9.474-17.404-15.442-24.512-6.586-7.846-4.717-13.283 5.436-25.222 10.153-11.94 19.771-15.982 13.444-32.662",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.502 184.322c-1.119-10.517-6.04-25.905-24.21-34.127-29.318-13.266-47.2-6.121-57.07 4.24-2.564 2.692-4.791 5.644-6.689 8.538a69.414 69.414 0 0 0 25.482 21.767l39.334 6.712a68.701 68.701 0 0 0 23.153-7.13",
    fill: "#6176F4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.16)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "aexzio5mdb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7ndp3xckha"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.233 46.069c0 25.442-20.647 46.068-46.116 46.068C20.647 92.137 0 71.511 0 46.07 0 20.626 20.647-.001 46.117-.001c25.469 0 46.116 20.627 46.116 46.07",
    fill: "#6176F4",
    mask: "url(#aexzio5mdb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.677 65.538c-6.599 2.198-17.998 5.678-25.892 3.155-7.894-2.524-21.471-2.524-15.472-9.779 6-7.255 9.788-7.886 7.578-11.67-2.21-3.786-17.998-22.397-.631-30.282 17.366-7.886 41.364 4.731 47.68 17.033 6.314 12.302-6.947 11.04-4.421 15.14 2.526 4.101 6.63 6.31 3.157 9.464-3.473 3.154-7.262 5.362-11.999 6.94",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.076 47.638-.29 28.096s13.04 3.891 14.433-7.386c.03-.252 2.074-10.404 2.074-10.404s1.47-14.503-16.217-10.306",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.076 47.638-.29 28.096s13.04 3.891 14.433-7.386c.03-.252 2.074-10.404 2.074-10.404s1.47-14.503-16.217-10.306z",
    stroke: "#000",
    strokeWidth: 2.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.142 21.188s-20.6 3.43-24.808.994C6.5 18.804 6.494 7.32 13.561 4.89c7.068-2.43 18.816 1.427 23.581 16.298",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.448 54.555c3.293 2.759 10.926 7.728 16.277 5.53 8.318-3.419 7.2-21.858 4.988-28.276-2.212-6.418-4.223-14.34-19.02-11.406-14.799 2.934-5.388 9.39-5.388 9.39s.373 5.255-1.654 6.67c-2.028 1.415-12.736 3.401 4.797 18.092",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.448 54.555c3.293 2.759 10.926 7.728 16.277 5.53 8.318-3.419 7.2-21.858 4.988-28.276-2.212-6.418-4.223-14.34-19.02-11.406-14.799 2.934-5.388 9.39-5.388 9.39s.373 5.255-1.654 6.67c-2.028 1.415-12.736 3.401 4.797 18.092z",
    stroke: "#000",
    strokeWidth: 2.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.728 29.994s-4.718.904-4.466 4.766c.253 3.86 2.533 6.307 2.533 6.307s-1.053 2.157-2.338 2.599M55.256 44.302s3.586 4.151 6.688 2.725",
    stroke: "#000",
    strokeWidth: 2.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.567 35.606c-.067-1.002-.708-1.775-1.43-1.726-.722.05-1.252.9-1.185 1.903.069 1.002.709 1.775 1.43 1.726.723-.05 1.252-.9 1.185-1.903M69.999 35.19c-.068-1.002-.709-1.775-1.43-1.727-.722.05-1.252.901-1.185 1.904.069 1.002.709 1.774 1.43 1.726.723-.05 1.252-.901 1.185-1.903",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.46 36.575c0 .326.017.65.045.972 1.9.484 3.925.757 6.036.757 10.592 0 19.18-6.609 19.18-14.76 0-2.037-.537-3.978-1.508-5.744C45.332 20.674 35.46 27.994 35.46 36.575",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.933 41.3a5.207 5.207 0 0 1-5.21 5.205 5.207 5.207 0 0 1-5.21-5.205 5.207 5.207 0 0 1 5.21-5.205c2.877 0 5.21 2.33 5.21 5.205",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.472 21.913c-3.324 1.624-5.084 5.531-5.029 9.23.056 3.696 1.633 7.205 3.522 10.384 1 1.682 2.106 3.328 2.724 5.185.617 1.856.685 4.005-.34 5.672-.87 1.412-2.38 2.278-3.609 3.394-1.23 1.115-2.247 2.82-1.663 4.374M21.352 82.398c1.906-4.714 7.69-10.246 24.434-9.818",
    stroke: "#000",
    strokeWidth: 2.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.101 90.275S55.64 77.243 61.733 76.7c6.092-.543 10.084-1.086 14.6.76 0 0 7.144 3.041 9.245 5.43 2.1 2.39 3.887 4.67 3.781 6.19-.105 1.521-.42 2.498-2.1 2.498-1.681 0-1.156 1.304-1.576 1.846-.42.544-1.176 1.381-2.639.924-1.817-.568-4.633-2.38-5.894-3.575-1.26-1.195-3.127-1.584-4.599-2.778-1.47-1.195-2.626-1.629-2.626-.869s1.261 6.408 1.367 8.797c.105 2.389.145 1.857-1.194 2.525-1.052.526-2.618-1.594-3.428-3.177-.946-1.847-1.997-4.779-2.627-5.104-.63-.326-8.298 6.842-27.942.108",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.46 90.718c2.58-1.19 23.787-18.663 38.049-14.352 12.46 3.766 14.209 9.095 15.156 10.409 1.043 1.448 1.895 5.047-2.526 4.416",
    stroke: "#000",
    strokeWidth: 2.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.825 81.36s12.367 7.57 13.156 10.41c.79 2.838-3.631 2.575-4.631 1.682-1-.894-11.946-8.57-14.21-9.095",
    stroke: "#000",
    strokeWidth: 2.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.088 86.25s1.21 8.306 1.158 9.83c-.053 1.525-1.21 2.524-1.947 2.156-.737-.368-5.473-9.884-5.473-9.884s-5.368 2.103-13.894 2.892",
    stroke: "#000",
    strokeWidth: 2.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.14 117.128c-1.028 5.7 2.766 11.155 8.472 12.18 5.707 1.028 11.167-2.761 12.194-8.462 1.028-5.702-2.765-11.155-8.473-12.182-5.707-1.026-11.166 2.763-12.193 8.464",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.267 117.434 28.33.655-6.363 35.306c-4.7 3.16-9.824 4.56-14.883 3.65-5.058-.91-9.371-4.007-12.672-8.606l5.588-31.005z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.722 127.043s-18.377 8.24-23.947-.311c-2.52-3.867-1.882-11.857.42-21.24.082-.332-4.774.178-3.233-2.945 4.84-9.813 14.386-21.476 23.973-26.627 0 0 .29 32.912 15.128 36.913",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.722 127.043s-18.377 8.24-23.947-.311c-2.52-3.867-1.882-11.857.42-21.24.082-.332-4.774.178-3.233-2.945 4.84-9.813 14.386-21.476 23.973-26.627 0 0 .29 32.912 15.128 36.913",
    stroke: "#000",
    strokeWidth: 2.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.784 77.49c-2.843 13.013.878 27.289 9.712 37.266M194.009 115.37c-3.029.187-5.372 3.318-6.15 5.99M164.931 111.217l-10.776 2.045s9.674 13.606 10.776-2.045z",
    stroke: "#000",
    strokeWidth: 2.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.374 99.569c-.883 1.204-.895 2.693-.028 3.328.867.634 2.285.173 3.167-1.03.883-1.203.896-2.693.028-3.328-.866-.634-2.284-.174-3.167 1.03",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.514 97.609a9.817 9.817 0 0 0-2.357-3.544",
    stroke: "#000",
    strokeWidth: 2.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 122.91c0 38.152-30.96 69.08-69.151 69.08-38.191 0-69.151-30.928-69.151-69.08 0-38.151 30.96-69.08 69.15-69.08C211.04 53.83 242 84.76 242 122.91z",
    stroke: "#000",
    strokeWidth: 2.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.974 190.277s-1.79-7.714-3.485-8.956c-1.696-1.242-3.48-2.17-5.613-2.164l-2.134.007s-.835-3.264-2.308-4.103c-1.471-.84-3.82-1.472-5.58-.822-1.759.65-2.766-2.225-4.654-2.447-1.889-.222-4.865-.955-6.826.95-1.961 1.907-2.585-.64-2.585-.64s-1.405-1.225-3.603 2.208c-2.198 3.433-4.726 8.082-4.747 11 0 0-1.157 6.116 1.897 6.93 3.052.814 4.725.398 4.725.398s.322 2.14 2.514 2.69c2.194.547 6.386.375 6.791.073.405-.302.106 1.503 2.226 1.89 2.119.389 5.516.347 5.998.126.481-.22.34 1.59 1.592 1.948 1.252.359 4.228 1.091 5.615-.203 1.387-1.294 3.516-5.798 3.63-6.82.114-1.022.834-1.313 1.39-1.373.554-.06 5.157-.692 5.157-.692",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.845 192.55c-3.744.758-5.31-.621-6.168-3.563-1.017-3.492 1.68-10.691 4.51-14.676 2.57-3.62 4.686-1.674 5.282-1.322",
    stroke: "#000",
    strokeWidth: 2.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.514 174.193s-3.454-2.958-5.814-2.984c-3.13-.033-4.43.834-5.687 4.588-1.258 3.752-4.556 15.325-1.52 18.45 1.831 1.884 4.29 2.934 8.096.848",
    stroke: "#000",
    strokeWidth: 2.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.649 178.675s-1.141-4.046-4.823-4.615c-3.68-.569-5.731 1.672-6.33 4.449-.599 2.776-2.87 11.229-3.025 12.984-.155 1.755-.133 5.113 2.911 6.215 2.344.85 5.715-.558 5.715-.558",
    stroke: "#000",
    strokeWidth: 2.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.727 189.554s-1.64-7.953-5.305-9.636c-3.665-1.684-7.102-1.306-8.36 2.447-1.257 3.753-2.794 11.916-2.794 11.916s-1.32 5.081 1.933 5.557c3.254.478 6.172.436 8.444-8.017",
    stroke: "#000",
    strokeWidth: 2.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.298 160.799h-66.5C4.834 160.799 0 155.969 0 150.01v-29.525c0-5.958 4.834-10.788 10.798-10.788h66.5c5.963 0 10.799 4.83 10.799 10.788v29.525c0 5.958-4.836 10.788-10.8 10.788",
    fill: "#6176F4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6176F4",
    d: "m75.782 177.832-43.575-43.53h43.575z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.557 9.602H118.03c-5.38 0-9.742 4.357-9.742 9.732v13.025c0 5.375 4.362 9.732 9.742 9.732h1.456v10.83l10.84-10.83h24.232c5.38 0 9.742-4.357 9.742-9.732V19.334c0-5.375-4.361-9.732-9.742-9.732z",
    stroke: "#000",
    strokeWidth: 2.103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.122 142.87c3.933 0 7.131-3.194 7.131-7.123 0-3.927-3.198-7.122-7.13-7.122-3.933 0-7.132 3.195-7.132 7.122 0 3.929 3.2 7.124 7.131 7.124M45.594 128.625c-3.931 0-7.13 3.195-7.13 7.123 0 3.927 3.199 7.123 7.13 7.123 3.932 0 7.13-3.196 7.13-7.123 0-3.928-3.198-7.123-7.13-7.123m0 2.102a5.029 5.029 0 0 1 5.026 5.021 5.029 5.029 0 0 1-5.026 5.02 5.028 5.028 0 0 1-5.025-5.02 5.029 5.029 0 0 1 5.025-5.02M67.065 128.625c-3.932 0-7.13 3.195-7.13 7.123 0 3.927 3.198 7.123 7.13 7.123 3.933 0 7.131-3.196 7.131-7.123 0-3.928-3.198-7.123-7.13-7.123m0 2.102a5.029 5.029 0 0 1 5.025 5.021 5.029 5.029 0 0 1-5.026 5.02 5.029 5.029 0 0 1-5.026-5.02 5.029 5.029 0 0 1 5.026-5.02",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2.103,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M121.987 22.219h28.629M121.987 28.528h28.629"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCollaboratorsAdded);
export default __webpack_public_path__ + "static/media/no-collaborators-added.fc76ae1ebbdbc8b47c6600929c95d9b1.svg";
export { ForwardRef as ReactComponent };